module.exports = __webpack_public_path__ + "static/img/Supermamalab_logo.1141500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Supermamalab_logo.png
// module id = WmlX
// module chunks = 0